<div class="calendar-header">
    @switch (type) {
        @case (datePickerHeaderType.RIGHT_DEFAULT) {
            <ng-container [ngTemplateOutlet]="rightDefault"></ng-container>
        }
        @case (datePickerHeaderType.RIGHT_DROPDOWN) {
            <ng-container [ngTemplateOutlet]="rightDropdown"></ng-container>
        }
        @case (datePickerHeaderType.CENTER_DEFAULT) {
            <ng-container [ngTemplateOutlet]="centerDefault"></ng-container>
        }
        @case (datePickerHeaderType.CENTER_DROPDOWN) {
            <ng-container [ngTemplateOutlet]="centerDropdown"></ng-container>
        }
        @default {
            <div class="help-message">
                <span>Type value: "{{type}}" no es valida. Cambie por: <br/></span>
                <small> {{ helpMessageOptions }}</small>
            </div>
        }
    }
</div>


<ng-template #rightDefault>
    <div class="right-default">
        <span class="month-year">{{ currentMonth }} {{ currentYear }}</span>
        <button class="prev-month" (click)="prevMonth.emit(true)">
            <mat-icon class="material-icons" inline="true">chevron_left</mat-icon>
        </button>
        <button class="next-month" (click)="nextMonth.emit(false)">
            <mat-icon class="material-icons" inline="true">chevron_right</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #rightDropdown>
    <div class="right-dropdown">
        <div class="month-year">
            <span>
                {{ currentMonth }}
                <mat-icon class="material-icons" [tabIndex]="0" role="button" (keydown.enter)="dropDownToggle.emit('monthView')" (click)="dropDownToggle.emit('monthView')">keyboard_arrow_down</mat-icon>
            </span>
            <span>
                {{ currentYear }}
                <mat-icon class="material-icons" [tabIndex]="0" role="button" (keydown.enter)="dropDownToggle.emit('yearView')" (click)="dropDownToggle.emit('yearView')">keyboard_arrow_down</mat-icon>
            </span>
        </div>
        <button class="prev-month" (click)="prevMonth.emit(true)">
            <mat-icon class="material-icons" inline="true">chevron_left</mat-icon>
        </button>
        <button class="next-month" (click)="nextMonth.emit(false)">
            <mat-icon class="material-icons" inline="true">chevron_right</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #centerDefault>
    <div class="center-default">
        <button class="prev-month" (click)="prevMonth.emit(true)">
            <mat-icon class="material-icons" inline="true">chevron_left</mat-icon>
        </button>
        <span class="month-year">{{ currentMonth }} {{ currentYear }}</span>
        <button class="next-month" (click)="nextMonth.emit(false)">
            <mat-icon class="material-icons" inline="true">chevron_right</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #centerDropdown>
    <div class="right-dropdown">
        <button class="prev-month" (click)="prevMonth.emit(true)">
            <mat-icon class="material-icons" inline="true">chevron_left</mat-icon>
        </button>
        <div class="month-year">
            <span>
                {{ currentMonth }}
                <mat-icon class="material-icons" [tabIndex]="0" role="button" (click)="dropDownToggle.emit('monthView')">keyboard_arrow_down</mat-icon>
            </span>
            <span>
                {{ currentYear }}
                <mat-icon class="material-icons" [tabIndex]="0" role="button" (click)="dropDownToggle.emit('yearView')">keyboard_arrow_down</mat-icon>
            </span>
        </div>
        <button class="next-month" (click)="nextMonth.emit(false)">
            <mat-icon class="material-icons" inline="true">chevron_right</mat-icon>
        </button>
    </div>
</ng-template>
